import {
    type KernelVersion,
    type ToEcdsaKernelSmartAccountParameters,
    toEcdsaKernelSmartAccount,
} from "permissionless/accounts";
import { getContract } from "viem";

// If the kernel contract is already deployed, we can get the actual version from the contract
export async function getKernelVersion<
    entryPointVersion extends "0.6" | "0.7",
    kernelVersion extends KernelVersion<entryPointVersion> = KernelVersion<entryPointVersion>,
>(
    parameters: ToEcdsaKernelSmartAccountParameters<entryPointVersion, kernelVersion>,
): Promise<KernelVersion<entryPointVersion>> {
    const account = await toEcdsaKernelSmartAccount(parameters);

    try {
        const contract = getContract({
            address: account.address,
            abi: [
                {
                    type: "function",
                    name: "eip712Domain",
                    inputs: [],
                    outputs: [
                        {
                            name: "fields",
                            type: "bytes1",
                            internalType: "bytes1",
                        },
                        {
                            name: "name",
                            type: "string",
                            internalType: "string",
                        },
                        {
                            name: "version",
                            type: "string",
                            internalType: "string",
                        },
                        {
                            name: "chainId",
                            type: "uint256",
                            internalType: "uint256",
                        },
                        {
                            name: "verifyingContract",
                            type: "address",
                            internalType: "address",
                        },
                        {
                            name: "salt",
                            type: "bytes32",
                            internalType: "bytes32",
                        },
                        {
                            name: "extensions",
                            type: "uint256[]",
                            internalType: "uint256[]",
                        },
                    ],
                    stateMutability: "view",
                },
            ],
            client: parameters.client,
        });

        const [, , version] = await contract.read.eip712Domain();

        return version as KernelVersion<entryPointVersion>;
    } catch {
        return parameters.version as KernelVersion<entryPointVersion>;
    }
}
